// opt in to HRM with Parcel JS
if (module.hot) {
  module.hot.accept();
}

// import blocks sassy styles ***********************
import "../blocks/countdown/countdown.scss";
import "../blocks/image-carousel/image-carousel.scss";
import "../blocks/testimonial/testimonial.scss";


// require blocks scripts *****************************
require('../blocks/countdown/countdown.js');
// require('../blocks/testimonial/testimonial.js');
